export enum NodeType {
    Scene = 'scene',
    Action = 'action',
    Character = 'character',
    Parans = 'parans',
    Dialogue = 'dialogue',
    Transition = 'transition',
    Shot = 'shot',
    PageBreak = 'page-break',
}
